import jwtDecode from 'jwt-decode'

export default defineNuxtRouteMiddleware(() => {
  const ownerToken = useCookie('owner:token')

  if (!ownerToken.value) {
    return navigateTo('/property-owner-callback')
  }

  try {
    const decoded = jwtDecode<{ exp?: number }>(ownerToken.value)
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      ownerToken.value = null
      return navigateTo('/property-owner-callback')
    }
  } catch {
    ownerToken.value = null
    return navigateTo('/property-owner-callback')
  }
})
